export default __webpack_public_path__ + "static/media/img_04.6545cdc2.jpg";